export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: '文爱社区是一个什么样的平台？',
    answer: '文爱社区是一个专注于文字情感表达与互动的高品质社区平台。我们为热爱文字交流的用户提供一个温暖、安全的空间，在这里你可以分享心声、发表文章、参与讨论、寻找共鸣，体验文字带来的温度与浪漫。',
  },
  {
    question: '如何加入文爱社区？',
    answer: '加入文爱社区非常简单！只需点击首页的「立即加入」按钮，填写基本注册信息，即可成为文爱社区的一员。注册完全免费，我们欢迎每一位热爱文字的朋友。',
  },
  {
    question: '社区中有哪些内容可以浏览？',
    answer: '文爱社区拥有丰富的文字内容分类，包括情感读本、诗歌杂谈、深夜电台、情侣交流、心灵成长、文艺生活等多个板块。您可以自由浏览、点赞、评论和分享您喜欢的文章。',
  },
  {
    question: '如何在社区中发布自己的文章？',
    answer: '注册成为社区成员后，点击导航栏的「发布」按钮，即可进入文章编辑页面。您可以使用富文本编辑器撰写文章，添加图片和标签，选择对应的分类后发布。我们鼓励原创内容，期待您的精彩分享。',
  },
  {
    question: '社区的内容审核标准是什么？',
    answer: '我们致力于维护一个健康、友善的社区环境。所有发布的内容需要遵守社区规范：禁止发布违法违规、暴力、色情、人身攻击等内容。我们鼓励真诚、温暖、有质量的文字交流。',
  },
  {
    question: '我可以与其他用户私信交流吗？',
    answer: '当然可以！文爱社区支持用户之间的私信功能。您可以与其他志同道合的文字爱好者进行一对一的深入交流，分享彼此的故事和感悟。',
  },
];